import React from "react"

import { Time } from "@tenforce/product-fields"

import { useAppSelector } from "../../../../../hooks"

import { Labels } from "../../../../../util/Translations"

import {
    getTimeZoneForLuxon,
    getLocale,
} from "../../../../applicationheader/components/usermenu/selector"

import { ICheckListViewActions, IQuestion } from "../../.."

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const TimeFieldValue = ({
    data,
    id,
    contextMenuActions: { updateSimpleValue },
    controls: { canEditValue },
}: Props): JSX.Element => {
    const currentValue = data as string

    const timeZone = useAppSelector((state) =>
        getTimeZoneForLuxon(state.userInfo),
    )
    const locale = useAppSelector((state) => getLocale(state.userInfo))

    return (
        <Time
            value={currentValue}
            locale={locale}
            timeZone={timeZone}
            fieldId="timeAnswer"
            isLoading={false}
            onSave={(value: string): void => {
                updateSimpleValue(id, value)
            }}
            isReadOnly={!canEditValue}
            placeholder={Labels.ClickHereToEdit}
        />
    )
}

export default TimeFieldValue
